import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Prediction} from '../../models/Prediction';
import * as RecordRTC from 'recordrtc';

@Injectable({
  providedIn: 'root'
})
export class SpeechService {
  mediaRecorder?: RecordRTC;
  index = 0;
  mediaDate?: Date;
  autoSaveMedia: any;
  onPredictionChart: any;
  onPredictionWave: any;
  onPredictionRadarChart: any;
  activeRecording: boolean;
  fileExtension?: string;

  public emotionalLocalMsg0?: string;
  public emotionalLocalMsgAngry?: string;
  public emotionalLocalMsgDisgust?: string;
  public emotionalLocalMsgFear?: string;
  public emotionalLocalMsgHappy?: string;
  public emotionalLocalMsgNeutral?: string;
  public emotionalLocalMsgSad?: string;
  public emotionalLocalMsgSurprise?: string;
  public emotionalLocalMsgContemptuous?: string;
  public emotionalLocalMsg9?: string;
  public emotionalLocalMsg10?: string;

  public emotionMaxIcon?: string;
  public emotionMaxText?: string;

  public serviceAnswer: any;

  constructor(private http: HttpClient) {
    this.activeRecording = false;
  }

  private initRecorder(stream: any, resetTimestamp = true) {
    this.mediaRecorder = new RecordRTC(stream, {
      type: 'audio',
      recorderType: RecordRTC.StereoAudioRecorder,
      numberOfAudioChannels: 2,
      mimeType: 'audio/wav',
      // // used by StereoAudioRecorder
      // // the range 22050 to 96000.
      // sampleRate: 22050,
      //
      // // used by StereoAudioRecorder
      // // the range 22050 to 96000.
      // // let us force 16khz recording:
      // desiredSampRate: 16000,
      //
      // // used by StereoAudioRecorder
      // // Legal values are (256, 512, 1024, 2048, 4096, 8192, 16384).
      // // bufferSize: 16384,
      // bufferSize: 256,
      // // used by StereoAudioRecorder
      //
      // // used by WebAssemblyRecorder
      // bitrate: 128000,
    });
    if (resetTimestamp) {
      this.mediaDate = new Date();
      this.index = 0;
    }
  }

  startRecording(stream: any, resetTimestamp = true) {
    console.log('startRecording');
    this.fileExtension = '.wav';
    this.initRecorder(stream, resetTimestamp);
    this.activeRecording = true;
    this.mediaRecorder?.startRecording();
  }

  private base64FromBlob(blob: any, onFinish: any): void {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      onFinish(reader.result);
    };
  }

  private getMediaFileName(): string {
    return (this.mediaDate ?? new Date()).toISOString() + '_' + this.index++ + this.fileExtension;
  }

  public sendMedia(callback: any = null, onError: any = null) {
    console.log('sendMedia');
    if (this.mediaRecorder) {
      if (this.mediaRecorder.state === 'recording') {
        this.mediaRecorder.stopRecording(() => {
          const copyBlob = this.mediaRecorder?.getBlob();

          const fileName = this.getMediaFileName();
          if (copyBlob) {
            // this.createLink(copyBlob, fileName) ;
            const file: File = new File([copyBlob], fileName, {
              type: 'audio/wav'
            });
            const fd: FormData = new FormData();
            fd.append('file', file);
            const url = URL.createObjectURL(copyBlob);
            this.uploadMedia(fd, url, null, onError);

            if (callback) {
              callback(url);
            }
          }
        });
      } else {
        if (callback) {
          callback();
        }
      }
    } else {
      if (callback) {
        callback();
      }
    }
  }

  public stopRecording(callback: any = null): void {
    console.log('stopRecording');
    if (this.autoSaveMedia) {
      this.autoSaveMedia.unsubscribe();
    }
    if (this.isRecorderActive()) {
      this.activeRecording = false;
      // this.sendMedia(callback);
      if (callback) {
        callback();
      }
    } else {
      if (callback) {
        callback();
      }
    }
  }

  public isRecorderActive() {
    return this.activeRecording;
  }


  private async uploadMedia(fd: any, url: string, onSuccess: any = null, onError: any = null) {
    /*const headers = new HttpHeaders().set('Content-Type', 'multipart/form-data');*/
    this.http.post(environment.speechApi, fd/*, {headers}*/)
      .subscribe((data: any) => {
        console.log(data);
        console.log('Upload Media successfully');
        if (onSuccess) {
          onSuccess();
        }
        if (data.status === 'ok') {
          const prediction = new Prediction(Prediction.FROM_SERVICE_TYPE, data.probabilities);
          this.loadEmotionalLocalMessages(prediction);
        } else {
          this.showEmotionalLocalMessage('No prediction');
        }
        if (this.onPredictionWave) {
          this.onPredictionWave(url);
        }
      }, err => {
        console.log(err);
        if (onError) {
          onError(err);
        }
      });
  }

  loadEmotionalLocalMessages(prediction: Prediction) {
    this.emotionalLocalMsgAngry = prediction.getAngryMsg();
    this.emotionalLocalMsgDisgust = prediction.getDisgustMsg();
    this.emotionalLocalMsgFear = prediction.getFearMsg();
    this.emotionalLocalMsgHappy = prediction.getHappyMsg();
    this.emotionalLocalMsgNeutral = prediction.getNeutralMsg();
    this.emotionalLocalMsgSad = prediction.getSadMsg();
    this.emotionalLocalMsgSurprise = prediction.getSurpriseMsg();
    this.emotionalLocalMsgContemptuous = prediction.getContemptuousMsg();
    const maxEmotion: any = prediction.getMaxEmotionIcon();
    this.emotionMaxIcon = maxEmotion.icon;
    this.emotionMaxText = maxEmotion.text;
    if (this.onPredictionChart) {
      this.onPredictionChart(prediction);
    }
    if (this.onPredictionRadarChart) {
      this.onPredictionRadarChart(prediction);
    }
  }

  showEmotionalLocalMessage(msg: string) {
    this.emotionalLocalMsgAngry = '';
    this.emotionalLocalMsgDisgust = '';
    this.emotionalLocalMsgFear = '';
    this.emotionalLocalMsgHappy = '';
    this.emotionalLocalMsgNeutral = '';
    this.emotionalLocalMsgSad = '';
    this.emotionalLocalMsgSurprise = '';
    this.emotionalLocalMsgContemptuous = '';
    this.emotionalLocalMsg9 = '';
    this.emotionalLocalMsg10 = '';
    this.emotionalLocalMsg0 = msg;
    this.emotionMaxIcon = '';
    this.emotionMaxText = '';
  }

  // Unused function for debug
  private createLink(blob: Blob, filename: string) {
    // const blob = new Blob([fileStr], {type: 'text/plain'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = url;
    a.download = filename;
    a.click();
  }
}
